import { useTranslation } from 'react-i18next'
import { Button } from '@chakra-ui/react'
import {
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from '../../../ui/dialog'
import { colors } from '../../../../utilities/colors'
import useStore from '../../../../store'
import { placeTypeIdByLocationType, DEFAULT_PLACE_TYPE_ID } from '../../../../constants/carpoolLocation'

export default function SaveLocationPrompt({ isOpen, label, location, quoteLocation, locationType, onComplete }) {
  const { t } = useTranslation()
  const createCarpoolDealerPlace = useStore((state) => state.createCarpoolDealerPlace)

  const resolvePlaceTypeId = () => {
    const resolvedType = location.type || locationType
    return placeTypeIdByLocationType[resolvedType] ?? DEFAULT_PLACE_TYPE_ID
  }

  const buildDealerPlacePayload = () => {
    const [firstName = '', ...rest] = (location.contact_name || '').trim().split(/\s+/)
    const lastName = rest.join(' ')
    return {
      name: location.name || '',
      address1: location.address || '',
      address2: location.address_2 || '',
      city: quoteLocation?.city || '',
      state: quoteLocation?.state || '',
      zip: quoteLocation?.postal_code || '',
      phone: location.contact_phone || '',
      email: location.contact_email || '',
      first_name: firstName,
      last_name: lastName,
      place_type: resolvePlaceTypeId(),
    }
  }

  const handleSave = async () => {
    await createCarpoolDealerPlace(buildDealerPlacePayload())
    onComplete()
  }

  return (
    <DialogRoot
      role="alertdialog"
      open={isOpen}
      onOpenChange={(details) => { if (!details.open) onComplete() }}
    >
      <DialogTrigger />
      <DialogContent bg={colors.deepOcean} width={{ base: 'calc(100% - 32px)', md: 'auto' }} mx="auto">
        <DialogTitle>
          <div className="text-lg font-bold m-2">{t('Save this location?')}</div>
        </DialogTitle>
        <DialogBody>
          <div className="text-sm text-grey-300 mx-2">
            {t('Save this {{label}} address to reuse it on future orders?', { label: label?.toLowerCase() })}
          </div>
        </DialogBody>
        <DialogFooter>
          <Button onClick={onComplete} borderRadius="full">
            {t('Not Now')}
          </Button>
          <Button bg={colors.green} onClick={handleSave} ml={3} p={2} borderRadius="full">
            {t('Save')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  )
}
